import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=8b34c44c"
import script from "./contact.vue?vue&type=script&lang=js"
export * from "./contact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageContact: require('/opt/build/repo/node_modules/@evince/site/lib/templates/contact.vue').default,LayoutBanner: require('/opt/build/repo/components/layout/Banner.vue').default})
